export const commonConfigs = {
  cullable: true,
  antialias: false,
  useContextAlpha: false,
};

export const webGameConfigs = {
  ...commonConfigs,
  width: 1440,
  height: 792,
  backgroundAlpha: 0,

  get applicationConfigs() {
    return {
      width: this.width,
      height: this.height,
      backgroundAlpha: this.backgroundAlpha,
    };
  },
};

export const mobileGameConfigs = {
  ...commonConfigs,
  width: 476,
  height: 568,
  // width: baseWidth,
  // height: window.innerWidth > window.innerHeight ? baseHeight : baseWidth,
  backgroundAlpha: 0,

  get applicationConfigs() {
    return {
      width: this.width,
      height: this.height,
      backgroundColor: this.backgroundColor,
      backgroundAlpha: this.backgroundAlpha,
    };
  },
};
